// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metric {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
    padding: 18px 10px;
    width: 100%;
    border: 1px solid #e5e7eb;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
    position: relative;
    cursor: default;
}

.metric:hover {
    border-color: transparent;
    box-shadow: none;
    transform: translateY(-2px);
}

.metric-content {
    position: relative;
    z-index: 2;
}

.metric-border-svg {
    position: absolute;
    inset: -1px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    overflow: visible;
    pointer-events: none;
    z-index: 1;
}

.metric-border-rect {
    x: 0.5px;
    y: 0.5px;
    width: calc(100% - 1px);
    height: calc(100% - 1px);
    rx: 12px;
    ry: 12px;
    fill: none;
    stroke: #5616ea;
    stroke-width: 1px;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    /* No vector-effect: see ChatHistories.css .platform-filter-border-rect. */
    shape-rendering: geometricPrecision;
}

.metric:hover .metric-border-rect {
    animation: metricBorderDraw 0.7s ease-out forwards;
}

@keyframes metricBorderDraw {
    to {
        stroke-dashoffset: 0;
    }
}

.metric-header {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 15px;
    color: #6b7280;
    margin-bottom: 10px;
    line-height: 1;
}

.metric-icon {
    font-size: 13px;
    color: #5616ea;
    position: relative;
    top: -1px;
}

.metric-value {
    margin: 0;
    padding: 0;
    font-size: 32px;
    font-weight: 600;
    color: #5616ea;
    line-height: 1;
}

@media (max-width: 768px) {
    .metric {
        padding: 16px 12px;
    }

    .metric-header {
        font-size: 11px;
    }

    .metric-value {
        font-size: 26px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/kpiElement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,6EAA6E;IAC7E,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,uBAAuB;IACvB,wBAAwB;IACxB,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,0EAA0E;IAC1E,mCAAmC;AACvC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".metric {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    background: #ffffff;\r\n    border-radius: 10px;\r\n    padding: 18px 10px;\r\n    width: 100%;\r\n    border: 1px solid #e5e7eb;\r\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\r\n    position: relative;\r\n    cursor: default;\r\n}\r\n\r\n.metric:hover {\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.metric-content {\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n.metric-border-svg {\r\n    position: absolute;\r\n    inset: -1px;\r\n    width: calc(100% + 2px);\r\n    height: calc(100% + 2px);\r\n    overflow: visible;\r\n    pointer-events: none;\r\n    z-index: 1;\r\n}\r\n\r\n.metric-border-rect {\r\n    x: 0.5px;\r\n    y: 0.5px;\r\n    width: calc(100% - 1px);\r\n    height: calc(100% - 1px);\r\n    rx: 12px;\r\n    ry: 12px;\r\n    fill: none;\r\n    stroke: #5616ea;\r\n    stroke-width: 1px;\r\n    stroke-dasharray: 100;\r\n    stroke-dashoffset: 100;\r\n    /* No vector-effect: see ChatHistories.css .platform-filter-border-rect. */\r\n    shape-rendering: geometricPrecision;\r\n}\r\n\r\n.metric:hover .metric-border-rect {\r\n    animation: metricBorderDraw 0.7s ease-out forwards;\r\n}\r\n\r\n@keyframes metricBorderDraw {\r\n    to {\r\n        stroke-dashoffset: 0;\r\n    }\r\n}\r\n\r\n.metric-header {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-weight: 500;\r\n    font-size: 15px;\r\n    color: #6b7280;\r\n    margin-bottom: 10px;\r\n    line-height: 1;\r\n}\r\n\r\n.metric-icon {\r\n    font-size: 13px;\r\n    color: #5616ea;\r\n    position: relative;\r\n    top: -1px;\r\n}\r\n\r\n.metric-value {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 32px;\r\n    font-weight: 600;\r\n    color: #5616ea;\r\n    line-height: 1;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .metric {\r\n        padding: 16px 12px;\r\n    }\r\n\r\n    .metric-header {\r\n        font-size: 11px;\r\n    }\r\n\r\n    .metric-value {\r\n        font-size: 26px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
